<template>
    <div class="container">
        <BackButton/>
        <Table
            :table-head="header"
            :table-body="body"
            :tableData="tableData"
            :isHover="false"
            :request-function="getMemberStatistics"
            more-mode="table"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    // import Table from "@/elements/Table/Table";
    import { getMemberStatistics } from "@/api/studioServices";
    import Table from "../../../elements/Table/Table";

    export default {
        components: {
            Table
            // Table,
        },

        data() {
            return {
                getMemberStatistics: getMemberStatistics,
            }
        },

        computed: {
            ...mapGetters([
                'tableData',
            ]),

            header() {
                return [
                    {
                        name: 'number',
                        adaptiveMode: 'mobile',
                        width: '40px'
                    },
                    {
                        name: 'gender',
                        adaptiveMode: 'mobile',
                        width: '43px'
                    },
                    {
                        name: 'firstName',
                        adaptiveMode: 'mobile',
                    },
                    {
                        name: 'surname',
                        adaptiveMode: 'tablet',
                    },
                    {
                        name: 'passCode',
                        adaptiveMode: 'none',
                        width: '119px'
                    },
                    {
                        name: 'guestStudio',
                        adaptiveMode: 'tablet',
                        width: '212px'
                    },
                    {
                        name: 'date',
                        adaptiveMode: 'none',
                        width: '121px'
                    }
                ]
            },

            body() {
                let arr = [];

                this.tableData.data && this.tableData.data.forEach(item => {
                    arr.push({
                        number: item.id,
                        gender: item.client.is_male,
                        firstName: item.client.first_name,
                        surname: item.client.last_name,
                        passCode: item.client.pass_code ? item.client.pass_code.code : '-',
                        guestStudio: item.studio_name,
                        date: item.created_at,
                    })
                });

                return arr;
            }
        },

        async created() {
            await this.$store.dispatch('PAGINATE', {page: 1, requestFunction: this.getMemberStatistics});
        },
    }
</script>

<style lang="sass" scoped>

</style>